// jQuery(document).ready(function($){
// 	    $(".collection-sidebar__group--1524772785241 .filter-button-title").text("Product Type");
// });

/* Open External Links in New Tab */
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}